import $api from "../http";
import {AxiosResponse} from "axios";
export default class SapperService {
    static async get_money(){
        return $api.get("/get_money_sapper")
    }
    static async get_game(){
        return $api.get("/get_game_sapper")
    }
    static async bet(amount,mines){
        return $api.post("/bet_sapper",{amount,mines})
    }
    static async check_position(position){
        return $api.post("/check_position_sapper",{position})
    }
}